import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import { FreightCarrier } from '../../../../freight-carriers/freightCarrier';
import { FormDropdown as Dropdown } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { FormDatePicker } from '@ami/react/core';
import moment from 'moment';
import { ordersService } from '../../../../orders/ordersService';
import { NotificationScheduleTypes } from '../../../../orders/order';

export default class MarkShippedModalComponent extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onShowUpdated: PropTypes.func.isRequired,
    onMarkShipped: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  state = {
    freightCarriers: [],
    freightCarrierId: null,
    trackingNumber: '',
    shippedDate: moment(new Date()),
    notificationSchedules: [],
    notificationSchedule: null,
  };

  hide = () => this.props.hideModal();

  componentDidMount() {
    this.loadNotificationSchedules();
  }

  async loadNotificationSchedules() {
    const notificationSchedules =
      await ordersService.getNotificationSchedules();
    notificationSchedules.push({ id: '', label: 'Do not notify' });
    this.setState({ notificationSchedules: notificationSchedules });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({
        freightCarriers: [],
        notificationSchedule: NotificationScheduleTypes.Immediately.id,
      });
      FreightCarrier.search().then((items) =>
        this.setState({ freightCarriers: items })
      );
    }
  }

  render() {
    const { show, onShowUpdated, onMarkShipped, submitting } = this.props;
    return (
      <Modal
        title="Mark as Shipped"
        okTitle="Save"
        cancelTitle="Cancel"
        show={show}
        showCancel={true}
        onOk={() =>
          onMarkShipped(
            this.state.freightCarrierId,
            this.state.trackingNumber,
            this.state.shippedDate,
            this.state.notificationSchedule
          )
        }
        onShowUpdated={onShowUpdated}
        submitting={submitting}
        closeOnOk={false}
      >
        <div className="mark-shipped-form">
          <div className="row">
            <div className="col">
              <Dropdown
                placeholder="None"
                isClearable={true}
                label="Freight Carrier"
                items={this.state.freightCarriers.map((x) => ({
                  id: x.id,
                  label: x.name,
                }))}
                selectedId={this.state.freightCarrierId}
                onChange={(freightCarrierId) =>
                  this.setState({ freightCarrierId })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormInput
                id="trackingNumber"
                label="Tracking Number"
                value={this.state.trackingNumber}
                onChange={(e) =>
                  this.setState({ trackingNumber: e.target.value })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormDatePicker
                label="Shipped Date"
                selected={this.state.shippedDate}
                onChange={(shippedDate) => this.setState({ shippedDate })}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Dropdown
                isClearable={true}
                items={this.state.notificationSchedules}
                onChange={(notificationSchedule) =>
                  this.setState({ notificationSchedule })
                }
                selectedId={this.state.notificationSchedule}
                className="w-full"
                label={'Notification Schedule'}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
